module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cJMG1"))).then(() => module.bundle.root('d0iPb'));